import { reverse } from 'named-urls'

import { routing } from '@utils/routing'

export const getOrderLink = (orderId: string) => ({
  pathname: reverse(routing.contributions.orders.order.self, { orderId }),
  search: location.search,
})
